import React from 'react'
import { withTranslation, Trans } from 'react-i18next'
import { Link } from 'react-router-dom'

import imgTrivia from '../../images/png/types/trivia.png'
import imgPersonality from '../../images/png/types/personality.png'
import imgQuotes from '../../images/png/types/quotes.png'
import imgPhotostory from '../../images/png/types/photostory.png'
import imgBeforeAfter from '../../images/png/types/before-after.png'
import imgRankBattle from '../../images/png/types/rank-battle.png'
import imgMemory from '../../images/png/types/memory.png'
import imgStory from '../../images/png/types/story.png'
import imgStoryFlipCards from '../../images/png/types/story_flipCards.png'
import imgStoryZoom from '../../images/png/types/story_zoom.png'
import imgStoryFindAndShow from '../../images/png/types/story_findAndShow.png'
import imgTimeline from '../../images/png/types/timeline.png'

import iconTrivia from '../../images/png/types/icon__trivia.svg'
import iconPhotostory from '../../images/png/types/icon__photostory.svg'
import iconMemory from '../../images/png/types/icon__memory.svg'
import iconQuotes from '../../images/png/types/icon__quotes.svg'
import iconPersonality from '../../images/png/types/icon__personality.svg'
import iconRankBattle from '../../images/png/types/icon__rank-battle.svg'
import iconBeforeAfter from '../../images/png/types/icon__before-after.svg'
import iconStory from '../../images/png/types/icon__story.svg'
import iconTimeline from '../../images/png/types/icon__timeline.svg'

const MechanicsBlock = ({
    exclude = ['instant-pages'],
    additionalClass = '',
    bgColor = '#ffd43a',
    fontColor = '#000000',
    title,
    subtitle,
    showStory = true,
    t,
}) => {
    return (
        <div className={`__mechanics-block ${additionalClass}`} style={{ backgroundColor: bgColor }}>
            {title ? (
                <h3 className="dark" style={{ color: fontColor }}>
                    {title}
                </h3>
            ) : null}
            {subtitle ? <p style={{ color: fontColor }}>{subtitle}</p> : null}
            {showStory ? (
                <div className="big-block">
                    <Link className="link" to="/products/instant-pages"></Link>
                    <div className="img">
                        <img src={imgStory} alt="" />
                    </div>
                    <div className="text">
                        <div className="title">{t('Combine different blocks and create interactive pages')}</div>
                        <div className="description">
                            {t(
                                'Easily create pages and longreads with interactive content that can be embedded anywhere: on your site, landing page or app with a simple copy and paste.',
                            )}
                        </div>
                    </div>
                    <Link className="link--mobile" to="/products/instant-pages" style={{ color: '#000000' }}>
                        <img src={iconStory} alt="" />
                        {t('Instant pages')}
                    </Link>
                </div>
            ) : null}
            <ul className="cards">
                {exclude.indexOf('instant-pages') === -1 ? (
                    <li className="card">
                        <Link className="link" to="/products/instant-pages"></Link>
                        <div className="image">
                            <img src={imgMemory} alt="" />
                        </div>
                        <p style={{ color: fontColor }}>{t('Memory')}</p>
                        <Link className="link--mobile" to="/products/memory-game" style={{ color: '#34C96D' }}>
                            <img src={iconMemory} alt="" />
                            {t('Memory')}
                        </Link>
                    </li>
                ) : null}
                {exclude.indexOf('trivia-quiz') === -1 ? (
                    <li className="card">
                        <Link className="link" to="/products/trivia-quiz"></Link>
                        <div className="image">
                            <img src={imgTrivia} alt="" />
                        </div>
                        <p style={{ color: fontColor }}>{t('Trivia')}</p>
                        <Link className="link--mobile" to="/products/trivia-quiz" style={{ color: '#FF5656' }}>
                            <img src={iconTrivia} alt="" />
                            {t('Trivia')}
                        </Link>
                    </li>
                ) : null}
                {exclude.indexOf('personality-quiz') === -1 ? (
                    <li className="card">
                        <Link className="link" to="/products/personality-quiz"></Link>
                        <div className="image">
                            <img src={imgPersonality} alt="" />
                        </div>
                        <p style={{ color: fontColor }}>{t('Personality')}</p>
                        <Link className="link--mobile" to="/products/personality-quiz" style={{ color: '#9560E6' }}>
                            <img src={iconPersonality} alt="" />
                            {t('Personality')}
                        </Link>
                    </li>
                ) : null}
                {exclude.indexOf('quotes') === -1 ? (
                    <li className="card">
                        <Link className="link" to="/products/quotes"></Link>
                        <div className="image">
                            <img src={imgQuotes} alt="" />
                        </div>
                        <p style={{ color: fontColor }}>{t('Quotes')}</p>
                        <Link className="link--mobile" to="/products/quotes" style={{ color: '#4B4E58' }}>
                            <img src={iconQuotes} alt="" />
                            {t('Quotes')}
                        </Link>
                    </li>
                ) : null}
                {exclude.indexOf('photostory') === -1 ? (
                    <li className="card">
                        <Link className="link" to="/products/photostory"></Link>
                        <div className="image">
                            <img src={imgPhotostory} alt="" />
                        </div>
                        <p style={{ color: fontColor }}>{t('Photostories')}</p>
                        <Link className="link--mobile" to="/products/photostory" style={{ color: '#24BFD8' }}>
                            <img src={iconPhotostory} alt="" />
                            {t('Photostories')}
                        </Link>
                    </li>
                ) : null}
                {exclude.indexOf('before-after') === -1 ? (
                    <li className="card">
                        <Link className="link" to="/products/before-after"></Link>
                        <div className="image">
                            <img src={imgBeforeAfter} alt="" />
                        </div>
                        <p style={{ color: fontColor }}>{t('Then & Now')}</p>
                        <Link className="link--mobile" to="/products/before-after" style={{ color: '#C86445' }}>
                            <img src={iconBeforeAfter} alt="" />
                            {t('Then & Now')}
                        </Link>
                    </li>
                ) : null}
                {exclude.indexOf('rank-battle') === -1 ? (
                    <li className="card">
                        <Link className="link" to="/products/rank-battle"></Link>
                        <div className="image">
                            <img src={imgRankBattle} alt="" />
                        </div>
                        <p style={{ color: fontColor }}>{t('Rank Battle')}</p>
                        <Link className="link--mobile" to="/products/rank-battle" style={{ color: '#2970FB' }}>
                            <img src={iconRankBattle} alt="" />
                            {t('Rank Battle')}
                        </Link>
                    </li>
                ) : null}
                {exclude.indexOf('memory-game') === -1 ? (
                    <li className="card">
                        <Link className="link" to="/products/memory-game"></Link>
                        <div className="image">
                            <img src={imgMemory} alt="" />
                        </div>
                        <p style={{ color: fontColor }}>{t('Memory')}</p>
                        <Link className="link--mobile" to="/products/memory-game" style={{ color: '#34C96D' }}>
                            <img src={iconMemory} alt="" />
                            {t('Memory')}
                        </Link>
                    </li>
                ) : null}
                {showStory ? (
                    <>
                        <li className="card">
                            <Link className="link" to="/products/instant-pages"></Link>
                            <div className="image" style={{ backgroundColor: '#f2f2f2' }}>
                                <img src={imgStoryFlipCards} alt="" />
                            </div>
                            <p style={{ color: fontColor }}>{t('Flip')}</p>
                            <Link className="link--mobile" to="/products/instant-pages" style={{ color: '#000000' }}>
                                <img src={iconStory} alt="" />
                                {t('Flip')}
                            </Link>
                        </li>
                        <li className="card">
                            <Link className="link" to="/products/interactive-image"></Link>
                            <div className="image" style={{ backgroundColor: '#f2f2f2' }}>
                                <img src={imgStoryZoom} alt="" />
                            </div>
                            <p style={{ color: fontColor }}>{t('Interactive Image')}</p>
                            <Link
                                className="link--mobile"
                                to="/products/interactive-image"
                                style={{ color: '#000000' }}
                            >
                                <img src={iconStory} alt="" />
                                {t('Interactive Image')}
                            </Link>
                        </li>
                        <li className="card">
                            <Link className="link" to="/products/instant-pages"></Link>
                            <div className="image" style={{ backgroundColor: '#f2f2f2' }}>
                                <img src={imgStoryFindAndShow} alt="" />
                            </div>
                            <p style={{ color: fontColor }}>{t('Find and Show')}</p>
                            <Link className="link--mobile" to="/products/instant-pages" style={{ color: '#000000' }}>
                                <img src={iconStory} alt="" />
                                {t('Find and Show')}
                            </Link>
                        </li>
                        <li className="card">
                            <Link className="link" to="/products/timeline"></Link>
                            <div className="image">
                                <img src={imgTimeline} alt="" />
                            </div>
                            <p style={{ color: fontColor }}>{t('Timeline')}</p>
                            <Link className="link--mobile" to="/products/timeline" style={{ color: '#441E87' }}>
                                <img src={iconTimeline} alt="" />
                                {t('Timeline')}
                            </Link>
                        </li>
                    </>
                ) : null}
                <li className="card fake">
                    <div className="fake-image">
                        <span>{t('New mechanics\nappear regularly')}</span>
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default withTranslation('translations')(MechanicsBlock)
